"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMinimalPlugins = void 0;
var _cn = require("@udecode/cn");
var _plateBasicMarks = require("@udecode/plate-basic-marks");
var _plateCommon = require("@udecode/plate-common");
var _plateAutoformat = require("@udecode/plate-autoformat");
var _plateEmoji = require("@udecode/plate-emoji");
var _plateHeading = require("@udecode/plate-heading");
var _plateList = require("@udecode/plate-list");
var _plateMention = require("@udecode/plate-mention");
var _plateParagraph = require("@udecode/plate-paragraph");
var _plateResetNode = require("@udecode/plate-reset-node");
var _plateBlockQuote = require("@udecode/plate-block-quote");
var _codeLeaf = require("../../../../plate-js/plate-ui/code-leaf");
var _listElement = require("../../../../plate-js/plate-ui/list-element");
var _mentionElement = require("../../../../plate-js/plate-ui/mention-element");
var _mentionInputElement = require("../../../../plate-js/plate-ui/mention-input-element");
var _paragraphElement = require("../../../../plate-js/plate-ui/paragraph-element");
var _plateBasicElements = require("@udecode/plate-basic-elements");
var _nonEditableElement = require("../../../../plate-js/plate-ui/non-editable-element");
var _todoListElement = require("../../../../plate-js/plate-ui/todo-list-element");
var _autoFormatLists = require("../../../../plate-js/auto-format/autoFormatLists");
var _autoformatMarks = require("../../../../plate-js/auto-format/autoformatMarks");
var _customMentionDeserialiserPlugin = require("../../../../plate-js/lib/custom-mention-deserialiser-plugin");
var _customActionItemDeserialiserPlugin = require("../../../../plate-js/lib/custom-action-item-deserialiser-plugin");
var _plateHorizontalRule = require("@udecode/plate-horizontal-rule");
var _hrElement = require("../../../../plate-js/plate-ui/hr-element");
var _blockQuoteElement = require("../../../../plate-js/plate-ui/block-quote-element");
var _headingElement = require("../../../../plate-js/plate-ui/heading-element");
var _plateLink = require("@udecode/plate-link");
var _linkElement = require("../../../../plate-js/plate-ui/link-element");
var _linkFloatingToolbar = require("../../../../plate-js/plate-ui/link-floating-toolbar");
var _plateTrailingBlock = require("@udecode/plate-trailing-block");
var _plateBreak = require("@udecode/plate-break");
var resetBlockTypesCommonRule = {
  types: [_plateBlockQuote.ELEMENT_BLOCKQUOTE, _plateList.ELEMENT_TODO_LI],
  defaultType: _plateParagraph.ELEMENT_PARAGRAPH
};

/*
Keeping the code below for reference, but it is not used in the current implementation

const resetBlockTypesCodeBlockRule = {
	types: [ELEMENT_CODE_BLOCK],
	defaultType: ELEMENT_PARAGRAPH,
	onReset: unwrapCodeBlock,
};

export const getPlugins = () =>

	createPlugins(
		[
			// Nodes
			createParagraphPlugin(),
			createHeadingPlugin(),
			createBlockquotePlugin(),
			createCodeBlockPlugin(),
			// createHorizontalRulePlugin(),
			// createLinkPlugin({
			// 	renderAfterEditable: LinkFloatingToolbar as RenderAfterEditable,
			// }),
			createImagePlugin(),
			createMediaEmbedPlugin(),
			createCaptionPlugin({
				options: {pluginKeys: [ELEMENT_IMAGE, ELEMENT_MEDIA_EMBED]},
			}),
			createMentionPlugin(),
			createTabbablePlugin(),
			//createTablePlugin(),
			//createTodoListPlugin(),
			//createExcalidrawPlugin(),

			// Marks
			createBasicMarksPlugin(),
			createFontColorPlugin(),
			createFontBackgroundColorPlugin(),
			createFontSizePlugin(),
			// createHighlightPlugin(),
			// createKbdPlugin(),

			// Block Style
			// createAlignPlugin({
			// 	inject: {
			// 		props: {
			// 			validTypes: [ELEMENT_PARAGRAPH, ELEMENT_H1, ELEMENT_H2, ELEMENT_H3],
			// 		},
			// 	},
			// }),
			createListPlugin(),
			createIndentPlugin({
				inject: {
					props: {
						validTypes: [
							ELEMENT_PARAGRAPH,
							ELEMENT_H1,
							ELEMENT_H2,
							ELEMENT_H3,
							ELEMENT_BLOCKQUOTE,
							ELEMENT_CODE_BLOCK,
						],
					},
				},
			}),
			createIndentListPlugin({
				inject: {
					props: {
						validTypes: [
							ELEMENT_PARAGRAPH,
							ELEMENT_H1,
							ELEMENT_H2,
							ELEMENT_H3,
							ELEMENT_BLOCKQUOTE,
							ELEMENT_CODE_BLOCK,
						],
					},
				},
			}),
			// createLineHeightPlugin({
			// 	inject: {
			// 		props: {
			// 			defaultNodeValue: 1.5,
			// 			validNodeValues: [1, 1.2, 1.5, 2, 3],
			// 			validTypes: [ELEMENT_PARAGRAPH, ELEMENT_H1, ELEMENT_H2, ELEMENT_H3],
			// 		},
			// 	},
			// }),

			// Functionality
			// createAutoformatPlugin(autoformatPlugin),
			createBlockSelectionPlugin({
				options: {
					sizes: {
						top: 0,
						bottom: 0,
					},
				},
			}),
			// createComboboxPlugin(),
			// createDndPlugin({
			// 	options: {enableScroller: true},
			// }),
			// createEmojiPlugin({
			// 	renderAfterEditable: EmojiCombobox as RenderAfterEditable,
			// }),
			createEmojiPlugin(),
			createExitBreakPlugin({
				options: {
					rules: [
						{
							hotkey: 'mod+enter',
						},
						{
							hotkey: 'mod+shift+enter',
							before: true,
						},
						{
							hotkey: 'enter',
							query: {
								start: true,
								end: true,
								allow: KEYS_HEADING,
							},
							relative: true,
							level: 1,
						},
					],
				},
			}),
			createNodeIdPlugin(),
			createResetNodePlugin({
				options: {
					rules: [
						{
							...resetBlockTypesCommonRule,
							hotkey: 'Enter',
							predicate: isBlockAboveEmpty,
						},
						{
							...resetBlockTypesCommonRule,
							hotkey: 'Backspace',
							predicate: isSelectionAtBlockStart,
						},
						{
							...resetBlockTypesCodeBlockRule,
							hotkey: 'Enter',
							predicate: isCodeBlockEmpty,
						},
						{
							...resetBlockTypesCodeBlockRule,
							hotkey: 'Backspace',
							predicate: isSelectionAtCodeBlockStart,
						},
					],
				},
			}),
			createSelectOnBackspacePlugin({
				options: {
					query: {
						allow: [ELEMENT_IMAGE, ELEMENT_MEDIA_EMBED, ELEMENT_HR ],
					},
				},
			}),

			createSoftBreakPlugin({
				options: {
					rules: [
						{hotkey: 'shift+enter'},
						{
							hotkey: 'enter',
							query: {
								allow: [ELEMENT_CODE_BLOCK, ELEMENT_BLOCKQUOTE, ELEMENT_TD ],
							},
						},
					],
				},
			}),
			createTabbablePlugin({
				options: {
					query: editor => {
						if (isSelectionAtBlockStart(editor)) return false;

						return !someNode(editor, {
							match: n => {
								return !!(
									n.type &&
									([ELEMENT_TABLE, ELEMENT_LI, ELEMENT_CODE_BLOCK].includes(n.type as string) ||
										n[KEY_LIST_STYLE_TYPE])
								);
							},
						});
					},
				},
				// plugins: [
				// 	{
				// 		key: 'tabbable_element',
				// 		isElement: true,
				// 		isVoid: true,
				// 		component: TabbableElement,
				// 	},
				// ],
			}),
			createTrailingBlockPlugin({
				options: {type: ELEMENT_PARAGRAPH},
			}),
			//dragOverCursorPlugin,

			// Collaboration
			//createCommentsPlugin(),

			// Deserialization
			createDeserializeDocxPlugin(),
			createDeserializeMdPlugin(),
			createJuicePlugin(),
		],
		{
			components: withPlaceholders( {
				// [ELEMENT_BLOCKQUOTE]: BlockquoteElement,
				// [ELEMENT_CODE_BLOCK]: CodeBlockElement,
				[ELEMENT_CODE_LINE]: CodeLineElement,
				// [ELEMENT_CODE_SYNTAX]: CodeSyntaxLeaf,
				// [ELEMENT_HR]: HrElement,
				// [ELEMENT_H1]: withProps(HeadingElement, {variant: 'h1'}),
				// [ELEMENT_H2]: withProps(HeadingElement, {variant: 'h2'}),
				// [ELEMENT_H3]: withProps(HeadingElement, {variant: 'h3'}),
				// [ELEMENT_H4]: withProps(HeadingElement, {variant: 'h4'}),
				// [ELEMENT_H5]: withProps(HeadingElement, {variant: 'h5'}),
				// [ELEMENT_H6]: withProps(HeadingElement, {variant: 'h6'}),
				// [ELEMENT_IMAGE]: ImageElement,

				// [ELEMENT_LINK]: LinkElement,
				// [ELEMENT_MEDIA_EMBED]: MediaEmbedElement,
				[ELEMENT_MENTION]: MentionElement,
				[ELEMENT_MENTION_INPUT]: MentionInputElement,
				[ELEMENT_LI]: withProps(PlateElement, {as: 'li'}),
				[ELEMENT_UL]: withProps(ListElement, {variant: 'ul'}),
				[ELEMENT_OL]: withProps(ListElement, {variant: 'ol'}),
				[ELEMENT_PARAGRAPH]: ParagraphElement,
				// [ELEMENT_TABLE]: TableElement,
				// [ELEMENT_TD]: TableCellElement,
				// [ELEMENT_TH]: TableCellHeaderElement,
				// [ELEMENT_TODO_LI]: TodoListElement,
				// [ELEMENT_TR]: TableRowElement,
				// [ELEMENT_EXCALIDRAW]: ExcalidrawElement,
				[MARK_BOLD]: withProps(PlateLeaf, {as: 'strong'}),
				[MARK_CODE]: CodeLeaf,
				// [MARK_HIGHLIGHT]: HighlightLeaf,
				[MARK_ITALIC]: withProps(PlateLeaf, {as: 'em'}),
				[MARK_STRIKETHROUGH]: withProps(PlateLeaf, {as: 's'}),
				[MARK_SUBSCRIPT]: withProps(PlateLeaf, {as: 'sub'}),
				[MARK_SUPERSCRIPT]: withProps(PlateLeaf, {as: 'sup'}),
				[MARK_UNDERLINE]: withProps(PlateLeaf, {as: 'u'}),
				// [MARK_KBD]: KbdLeaf,
				// [MARK_COMMENT]: CommentLeaf,
			}, //)
		}
	);
*/

function getComponents(toggles) {
  var _components;
  var components = (_components = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_components, _plateParagraph.ELEMENT_PARAGRAPH, _paragraphElement.ParagraphElement), _plateHeading.ELEMENT_H1, (0, _cn.withProps)(_headingElement.HeadingElement, {
    variant: 'h1'
  })), _plateHeading.ELEMENT_H2, (0, _cn.withProps)(_headingElement.HeadingElement, {
    variant: 'h2'
  })), _plateHeading.ELEMENT_H3, (0, _cn.withProps)(_headingElement.HeadingElement, {
    variant: 'h3'
  })), _plateBasicMarks.MARK_BOLD, (0, _cn.withProps)(_plateCommon.PlateLeaf, {
    as: 'strong'
  })), _plateBasicMarks.MARK_CODE, _codeLeaf.CodeLeaf), _plateBasicMarks.MARK_ITALIC, (0, _cn.withProps)(_plateCommon.PlateLeaf, {
    as: 'em'
  })), _plateBasicMarks.MARK_STRIKETHROUGH, (0, _cn.withProps)(_plateCommon.PlateLeaf, {
    as: 's'
  })), _plateBasicMarks.MARK_UNDERLINE, (0, _cn.withProps)(_plateCommon.PlateLeaf, {
    as: 'u'
  })), _plateList.ELEMENT_LI, (0, _cn.withProps)(_plateCommon.PlateElement, {
    as: 'li'
  })), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_components, _plateList.ELEMENT_UL, (0, _cn.withProps)(_listElement.ListElement, {
    variant: 'ul'
  })), _plateList.ELEMENT_OL, (0, _cn.withProps)(_listElement.ListElement, {
    variant: 'ol'
  })), _plateMention.ELEMENT_MENTION, _mentionElement.MentionElement), _plateMention.ELEMENT_MENTION_INPUT, _mentionInputElement.MentionInputElement), _nonEditableElement.ELEMENT_NON_EDITABLE_CONTENT, _nonEditableElement.NonEditableContentElement), _plateHorizontalRule.ELEMENT_HR, _hrElement.HrElement), _plateBlockQuote.ELEMENT_BLOCKQUOTE, _blockQuoteElement.BlockquoteElement), _plateLink.ELEMENT_LINK, _linkElement.LinkElement));
  if (toggles.todoList) {
    components[_plateList.ELEMENT_TODO_LI] = _todoListElement.TodoListElement;
  }
  return components;
}
function getPlugins(toggles) {
  var plugins = [(0, _plateBasicElements.createBasicElementsPlugin)(), (0, _plateHeading.createHeadingPlugin)(), (0, _plateBasicMarks.createBasicMarksPlugin)(), (0, _plateEmoji.createEmojiPlugin)(), (0, _plateHeading.createHeadingPlugin)(), (0, _plateParagraph.createParagraphPlugin)(), (0, _plateList.createListPlugin)(), (0, _plateLink.createLinkPlugin)({
    renderAfterEditable: _linkFloatingToolbar.LinkFloatingToolbar
  }), (0, _customActionItemDeserialiserPlugin.createActionItemDeserializerPlugin)(), (0, _plateResetNode.createResetNodePlugin)({
    options: {
      rules: [_objectSpread({}, resetBlockTypesCommonRule, {
        hotkey: 'Enter',
        predicate: _plateCommon.isBlockAboveEmpty
      }), _objectSpread({}, resetBlockTypesCommonRule, {
        hotkey: 'Backspace',
        predicate: _plateCommon.isSelectionAtBlockStart
      })]
    }
  }), (0, _plateTrailingBlock.createTrailingBlockPlugin)({
    options: {
      type: _plateParagraph.ELEMENT_PARAGRAPH
    }
  }), (0, _plateBreak.createExitBreakPlugin)({
    options: {
      rules: [{
        hotkey: 'mod+enter'
      }, {
        hotkey: 'mod+shift+enter',
        before: true
      }, {
        hotkey: 'enter',
        query: {
          start: true,
          end: true,
          allow: _plateHeading.KEYS_HEADING
        },
        relative: true,
        level: 1
      }]
    }
  }), (0, _plateAutoformat.createAutoformatPlugin)({
    options: {
      rules: [].concat(_toConsumableArray(_autoFormatLists.autoformatLists), _toConsumableArray(_autoformatMarks.autoformatMarks)),
      enableUndoOnDelete: true
    }
  }), (0, _plateMention.createMentionPlugin)({
    options: {
      key: 'people-mention',
      trigger: '@',
      createMentionNode: function createMentionNode(item, _meta) {
        return (0, _customMentionDeserialiserPlugin.buildMentionNode)(item.key, item.text);
      }
    }
  }), (0, _plateMention.createMentionPlugin)({
    key: 'label-mention',
    options: {
      trigger: '#',
      createMentionNode: function createMentionNode(item, _meta) {
        return (0, _customMentionDeserialiserPlugin.buildMentionNode)(item.key, item.text);
      }
    }
  }), (0, _customMentionDeserialiserPlugin.createMentionDeserializerPlugin)(), (0, _nonEditableElement.createNonEditableContentPlugin)({
    component: _nonEditableElement.NonEditableContentElement
  }), (0, _plateHorizontalRule.createHorizontalRulePlugin)(), (0, _plateBlockQuote.createBlockquotePlugin)()];
  if (toggles.todoList) {
    plugins.push((0, _plateList.createTodoListPlugin)());
  }
  return plugins;
}
var getMinimalPlugins = function getMinimalPlugins(toggles) {
  return (0, _plateCommon.createPlugins)(getPlugins(toggles), {
    components: getComponents(toggles)
  });
};
exports.getMinimalPlugins = getMinimalPlugins;